import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import AsyncStorage from "@react-native-async-storage/async-storage";

interface SelectedSiteState {
  selectedSiteId: string | null;
  setSelectedSiteId: (id: string | null) => void;
}

export const useSelectedSiteStore = create<SelectedSiteState>()(
  persist(
    (set) => ({
      selectedSiteId: null,
      setSelectedSiteId: (id) => set({ selectedSiteId: id }),
    }),
    {
      name: "selected-site-store",
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
);
